
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IUpdateUsernameModel } from '@/models/account.model';

  import tokenService from '@/services/token.service';
  import routeService from '@/services/route.service';
  import userService from '@/services/user.service';
  import accountService from '../../services/account.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'isLoading'
      ])
    }
  })
  export default class UpdateUsername extends Vue {
    data() {
      return {
        studio: '',
        hasErrors: false,
        isUpdateLoading: false,
        errors: new Array<IErrorModel>(),
        form: {} as IUpdateUsernameModel
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;

      if (tokenService.hasToken(this) == null) {
        routeService.redirectToLogin(this, this.$router.currentRoute.path);
      }
    }

    updateUsername() {
      if (this.$data.isUpdateLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isUpdateLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "profile/user/" + this.$store.getters.user.Id + "/update-username";

        accountService.post<IUpdateUsernameModel, object>(this, url, this.$data.form, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isUpdateLoading = false;
            userService.updateUser(this, false, false, this.$store.getters.user.Id, this.$store.getters.token.Value, undefined, true);
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
            this.$data.isUpdateLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    updateFormValue(parameter: string, value: string) {
      this.$set(this.$data.form, parameter, value);
    }
  }
